import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from "react-dom/client";
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './store'
import './index.css'
const root=ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

reportWebVitals()
